// extracted by mini-css-extract-plugin
module.exports = {"banner":"QunosuiteBanner_banner__FwYJT","bold":"QunosuiteBanner_bold__M84TD"};